// extracted by mini-css-extract-plugin
export var loader = "BaseLayout-module--loader--BF7zi";
export var cookieBanner = "BaseLayout-module--cookieBanner--2-Zio";